<template>
  <v-layout align-start v-resize="getDimensions">
    <v-flex>
      <v-app-bar>
        <v-toolbar-title class="font-weight-black primary--text"
          >Uniforme</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="exportarExcel"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> sim_card_download </v-icon>
            </v-btn>
          </template>
          <span>Exportar a Excel</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="mostrarCarga"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> file_upload </v-icon>
            </v-btn>
          </template>
          <span>Carga masiva de datos</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="addItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> add </v-icon>
            </v-btn>
          </template>
          <span>Ingresar nuevo registro</span>
        </v-tooltip>
      </v-app-bar>
      <v-data-table
        dense
        :headers="headers"
        :items="uniformes"
        :items-per-page="2"
        :search="search"
        sort-by="codigo"
        class="elevation-1"
        :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Filas por página',
          'items-per-page-options': [50, 100, 150, -1],
        }"
      >
        <template v-slot:[`item.opciones`]="{ item }">
          <v-btn x-small text dark color="primary" @click="editItem(item)">
            <v-icon x-small>edit</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado == 'A'">
            <v-btn color="success" x-small text dark @click="desactivar(item)">
              <v-icon x-small>check</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn color="error" x-small text dark @click="activar(item)">
              <v-icon x-small>block</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.genero`]="{ item }">
          <v-chip
            v-for="(gen, index) in JSON.parse(item.genero)"
            class="ma-2"
            :color="gen == 'Masculino' ? 'accent' : 'femm'"
            text-color="white"
            x-small
            :key="index"
          >
            {{ gen }}
          </v-chip>
        </template>

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="font-weight-black primary--text">
            </v-toolbar-title>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda General"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchCodigoValue"
              append-icon="search"
              label="Búsqueda por código"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchDescripcionValue"
              append-icon="search"
              label="Búsqueda por descripción"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" persistent max-width="800px">
              <v-card ref="form">
                <v-app-bar color="white" elevate-on-scroll flat>
                  <span>{{ "DETALLE DE  " + descripcion }} </span>

                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="guardar"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> save </v-icon>
                      </v-btn>
                    </template>
                    <span>Guardar Uniforme</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="close"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        fab
                      >
                        <v-icon dark> close </v-icon>
                      </v-btn>
                    </template>
                    <span>Volver</span>
                  </v-tooltip>
                </v-app-bar>

                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        dense
                        ref="codigo"
                        v-model="codigo"
                        :rules="[$rules.requerido, $rules.max10, $rules.min2]"
                        :error-messages="errorMessages"
                        label="Código"
                        placeholder="Código"
                        required
                      ></v-text-field>
                    
                     
                      <v-text-field
                        outlined
                        dense
                        ref="descripcion"
                        v-model="descripcion"
                        :rules="[$rules.requerido, $rules.max50, $rules.min2]"
                        :error-messages="errorMessages"
                        label="Descripción"
                        placeholder="Descripción"
                        required
                      ></v-text-field>
                    
                     
                   
                      <v-text-field
                        outlined
                        dense
                        reverse
                        ref="monto"
                        v-model="monto"
                        :rules="[$rules.numero, $rules.requerido]"
                        :error-messages="errorMessages"
                        label="Precio"
                        required
                        style="text-align: right"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      
                    
                      <v-autocomplete
                        outlined
                        dense
                        chips
                        deletable-chips
                        multiple
                        ref="genero"
                        v-model="genero"
                        :items="generos"
                        :rules="[$rules.requerido2]"
                        :error-messages="errorMessages"
                        label="Sexo"
                        required
                      >
                      </v-autocomplete>
                    
                      
                    
                      <v-autocomplete
                        dense
                        outlined
                        ref="mes_compra"
                        v-model="mes_compra"
                        :items="meses"
                        :rules="[$rules.requerido]"
                        :error-messages="errorMessages"
                        item-text="descripcion"
                        item-value="id"
                        label="Mes de compra"
                        required
                      ></v-autocomplete>
                   
                     
                    </v-col>
                  </v-row>
                  <div v-if="!editCodigo">
                    <v-app-bar color="white" elevate-on-scroll flat>
                      <span class="font-weight-black primary--text"
                        >{{ "Listado de cargos asignados" }}
                      </span>

                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            large
                            @click="addCargo"
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon dark> add </v-icon>
                          </v-btn>
                        </template>
                        <span>Asignar cargo al Uniforme</span>
                      </v-tooltip>
                    </v-app-bar>
                    <v-sheet class="overflow-y-auto" :max-height="height - 400">
                      <v-data-table
                        dense
                        fixed-header
                        :height="height - 500"
                        :headers="headersCargo"
                        :items="CargoList"
                        :search="searchCargo"
                        :page.sync="page"
                        :items-per-page="itemsPerPage"
                        sort-by="descripcion"
                        class="elevation-1"
                        :header-props="{
                          'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                        }"
                        :footer-props="{
                          showFirstLastPage: true,
                          'items-per-page-text': 'Filas por página',
                          'group-text': 'Agrupar',
                          'items-per-page-options': [-1, 20, 30, 40, 50, -1],
                          'all-rows': 'Todos',
                        }"
                      >
                        <template v-slot:[`item.opciones`]="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                text
                                x-small
                                dark
                                color="primary"
                                @click="duplicarItemCargo(item)"
                              >
                                <v-icon x-small>fa-solid fa-copy</v-icon>
                              </v-btn>
                            </template>
                            <span>Duplicar</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                text
                                x-small
                                dark
                                color="primary"
                                @click="editItemCargo(item)"
                              >
                                <v-icon x-small>edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                text
                                x-small
                                dark
                                color="primary"
                                @click="deleteItemCargo(item)"
                              >
                                <v-icon x-small>delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Eliminar</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:[`item.id_ciudad`]="{ item }">
                          <div v-if="item.id_ciudad">
                            <v-chip
                              v-for="(ciu, index) in JSON.parse(item.id_ciudad)"
                              class="ma-2"
                              color="primary"
                              text-color="white"
                              x-small
                              :key="index"
                            >
                              {{
                                ciudades.find((cds) => cds.id === ciu)
                                  .descripcion
                              }}
                            </v-chip>
                          </div>
                        </template>

                        <template v-slot:top>
                          <v-divider vertical></v-divider>
                          <v-spacer></v-spacer>
                          <v-spacer></v-spacer>

                          <v-dialog
                            v-model="dialogBorrarCargo"
                            persistent
                            max-width="290"
                          >
                            <v-card>
                              <v-card-title class="headline"
                                >¿Está seguro?</v-card-title
                              >
                              <v-card-text
                                >Esta acción borrará la asignación de Cargo al
                                Uniforme.</v-card-text
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="dialogBorrarCargo = false"
                                  >Cancelar</v-btn
                                >
                                <v-btn
                                  color="primary"
                                  text
                                  @click="eliminarCargo()"
                                  >Continuar</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:no-data>
                          <v-btn color="primary" @click="listarUniformeCargo"
                            >Reset</v-btn
                          >
                        </template>
                      </v-data-table>
                    </v-sheet>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>

            <v-dialog
              dense
              persistent
              v-model="dialogCargosPendientes"
              max-width="800px"
            >
              <v-card ref="formCargo">
                <v-app-bar color="white" elevate-on-scroll flat>
                  <span class="font-weight-black primary--text">{{
                    showTablaCargos
                      ? "Cargos sin asignar a " + descripcion
                      : cargoDescripcion
                  }}</span>

                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        large
                        @click="guardarCargo"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> save </v-icon>
                      </v-btn>
                    </template>
                    <span>Guardar Asignaciones</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        @click="closeCargo"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        fab
                      >
                        <v-icon dark> close </v-icon>
                      </v-btn>
                    </template>
                    <span>Volver</span>
                  </v-tooltip>
                </v-app-bar>

                <v-card-text>
                  <v-sheet
                    class="overflow-y-auto"
                    :max-height="height - 420"
                    v-show="showTablaCargos"
                  >
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        dense
                        outlined
                        class="text-xs-center"
                        v-model="filtroPersonaPer"
                        append-icon="search"
                        label="Buscar"
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-data-table
                      dense
                      fixed-header
                      :height="height - 520"
                      :page.sync="page"
                      :items="cargoPendientesList"
                      ref="id_cargo"
                      v-model="id_cargo"
                      :headers="headersCargoPendiente"
                      :items-per-page="itemsPerPage"
                      item-key="id"
                      show-select
                      sort-by="mes"
                      class="elevation-1"
                      :search="filtroPersonaPer"
                      :header-props="{
                        'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                      }"
                      :footer-props="{
                        showFirstLastPage: true,
                        'items-per-page-text': 'Filas por página',
                        'group-text': 'Agrupar',
                        'items-per-page-options': [-1, 20, 30, 40, 50, -1],
                        'all-rows': 'Todos',
                      }"
                    >
                      <template v-slot:[`item.fecha_ingreso`]="{ item }">
                        <div>
                          {{
                            item.fecha_ingreso === null
                              ? ""
                              : formatoFechaSpanish(item.fecha_ingreso)
                          }}
                        </div>
                      </template>
                      <template v-slot:[`item.fecha_salida`]="{ item }">
                        <div>
                          {{
                            item.fecha_salida === null
                              ? ""
                              : formatoFechaSpanish(item.fecha_salida)
                          }}
                        </div>
                      </template>
                      <template v-slot:no-data>
                        No hay datos de personas disponibles
                      </template>
                    </v-data-table>
                  </v-sheet>

                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      outlined
                      dense
                      chips
                      deletable-chips
                      multiple
                      ref="id_ciudad"
                      v-model="id_ciudad"
                      :items="ciudades"
                      :rules="[$rules.requerido2]"
                      :error-messages="errorMessages"
                      item-text="descripcion"
                      item-value="id"
                      label="Ciudades"
                      required
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      outlined
                      dense
                      reverse
                      ref="frecuencia"
                      v-model="frecuencia"
                      :rules="[$rules.numero, $rules.requerido]"
                      :error-messages="errorMessages"
                      label="Dotaciones al año"
                      required
                    ></v-text-field>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";

export default {
  data() {
    return {
      width: 0,
      height: 0,
      isMobile: false,
      uniformes: [],
      fruits: ["apple", "banana", "orange"],
      dialog: false,
      dialogUpload: false,
      dialogCargosPendientes: false,
      dialogBorrarCargo: false,
      cargoDescripcion: "",
      filtroPersonaPer: "",

      page: 1,
      itemsPerPage: 12,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Sexo",
          value: "genero",
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Precio",
          value: "monto",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Activo",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersCargo: [
        {
          text: "Cargo",
          value: "cargo",
        },
        {
          text: "Dotaciones",
          value: "frecuencia",
          align: "right",
        },
        {
          text: "Ciudades",
          value: "id_ciudad",
          align: "left",
        },
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          align: "center",
        },
      ],
      headersCargoPendiente: [
        {
          text: "Código",
          value: "codigo",
        },
        {
          text: "Área",
          value: "area",
          align: "left",
        },
        {
          text: "Subarea",
          value: "subarea",
          align: "left",
        },
        {
          text: "Cargo",
          value: "descripcion",
          align: "left",
        },
      ],

      meses: [
        { id: 1, descripcion: "ENERO" },
        { id: 2, descripcion: "FEBRERO" },
        { id: 3, descripcion: "MARZO" },
        { id: 4, descripcion: "ABRIL" },
        { id: 5, descripcion: "MAYO" },
        { id: 6, descripcion: "JUNIO" },
        { id: 7, descripcion: "JULIO" },
        { id: 8, descripcion: "AGOSTO" },
        { id: 9, descripcion: "SEPTIEMBRE" },
        { id: 10, descripcion: "OCTUBRE" },
        { id: 11, descripcion: "NOVIEMBRE" },
        { id: 12, descripcion: "DICIEMBRE" },
      ],

      search: "",
      searchCargo: "",
      searchCodigoValue: "",
      searchDescripcionValue: "",
      usuario: this.$store.state.usuario.user,
      CargoList: [],
      itemUniforme:{},
      ciudades: [],
      showTablaCargos: false,
      editedIndex: -1,

      editCodigo: false,
      mostrarErrores: false,

      id: "",
      idCargo: "",
      id_cargo: [],
      id_ciudad: [],
      codigo: "",
      descripcion: "",
      frecuencia: "",
      monto: "",
      mes_compra: "",

      file: null,
      genero: [],
      valida: 0,

      validaMensaje: [],
      cargoList: [],
      cargoPendientesList: [],
      areaList: [],
      generos: ["Masculino", "Femenino"],
      adCodigo: "",
      errorMessages: "",
      errorMessagesCargo: "",
      error: "",
      itemCargo:{},
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        genero: this.genero,
        monto: this.monto,
        mes_compra: this.mes_compra,
      };
    },

    formCargo() {
      return {
        frecuencia: this.frecuencia,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
      this.errorMessagesCargo = "";
    },
  },
  mounted() {
    this.getDimensions();
  },

  created() {
    this.listar();

    this.selectCiudades();
  },

  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },
    closeCargo() {
      this.dialogCargosPendientes = false;
    },

    exportarExcel() {
      let me = this;
      try {
        json2excel({
          data: me.uniformes,
          name: "Uniforme",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);

        axios
          .put("api/uniformes/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/uniformes/listar")
        .then(function (response) {
          me.uniformes = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarUniformeCargo() {
      let me = this;

      axios
        .get("api/uniforme_cargos/listarUniformeCargo/" + this.id)
        .then(function (response) {
          me.CargoList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ListarCargosSinUniforme() {
      let me = this;

      axios
        .get("api/cargos/ListarCargosSinUniforme/" + me.id)
        .then(function (response) {
          me.cargoPendientesList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    ListarCargo() {
      let me = this;
      axios
        .get("api/cargos/listar/")
        .then(function (response) {
          me.cargoList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectArea() {
      let me = this;
      axios
        .get("api/areas/select")
        .then(function (response) {
          me.areaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectCiudades() {
      let me = this;
      axios
        .get("api/ciudades/SelectDepartamentosBolivia")
        .then(function (response) {
          me.ciudades = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarCarga() {
      this.dialogUpload = true;
    },

    editItem(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;

      this.genero =
        item.genero === "" ? JSON.parse("[]") : JSON.parse(item.genero);

      this.monto = item.monto;
      this.mes_compra = item.mes_compra;
      this.editedIndex = 1;
      this.editCodigo = false;
      this.listarUniformeCargo();

      this.selectArea();

      this.dialog = true;
    },

    addItem() {
      this.editCodigo = true;
      this.dialog = true;
    },

    addCargo() {
      this.showTablaCargos = true;
      this.dialogCargosPendientes = true;
      this.ListarCargosSinUniforme();
    },
    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    deleteItemCargo(item) {
      this.itemUniforme=item;
      this.id_cargo = item.id_cargo;
      this.dialogBorrarCargo = true;
    },
    editItemCargo(item) {
      this.itemCargo = item;
      this.id_ciudad =
        item.id_ciudad === "" ? JSON.parse("[]") : JSON.parse(item.id_ciudad);
      this.cargoDescripcion = item.cargo;
      this.frecuencia = item.frecuencia;
      this.showTablaCargos = false;
      this.idCargo = item.id_cargo;
      this.dialogCargosPendientes = true;
      //this.id_cargo = [item.id_cargo];
    },
    duplicarItemCargo(item) {
      let me = this;
      console.log(item);
        axios
          .post("api/Uniforme_cargos/duplicar", {
            id_uniforme: item.id_uniforme,
            id_cargo: item.id_cargo,            
            frecuencia: item.frecuencia,            
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCargo();
            me.listarUniformeCargo();

            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
    },

    

    close() {
      this.dialog = false;
      this.limpiar();
    },

    eliminarCargo() {
      let me = this;
      console.log("itemUniforme", me.itemUniforme);
      axios
        .put(
          "api/uniforme_cargos/EliminarUniformeCargo/" +
            me.itemUniforme.id +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.listarUniformeCargo();
          me.$store.dispatch("setSnackbar", {
            text: "Cargo eliminada exitosamente.",
            color: "success",
          });
          me.dialogBorrarCargo = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";

      this.genero = [];

      this.monto = "";
      this.mes_compra = "";
      this.validaMensaje = [];
      this.editedIndex = -1;
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      let me = this;

      if (this.editedIndex > -1) {
        //codigo para editar
        axios
          .put("api/uniformes/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            genero: me.genero,
            id_ciudad: me.id_ciudad,
            frecuencia: me.frecuencia,
            monto: me.monto,
            mes_compra: me.mes_compra,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/uniformes/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            genero: me.genero,
            frecuencia: me.frecuencia,
            id_ciudad: me.id_ciudad,
            monto: me.monto,
            mes_compra: me.mes_compra,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.editCodigo = false;
            me.listar();
            me.id = response.data;
            me.editedIndex = 1;
            me.listarUniformeCargo();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarCargo() {
      if (this.validarCargo() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.id_cargo.length == 0 && this.showTablaCargos) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos un cargo.",
          color: "error",
        });
        return;
      }
      if (this.id_ciudad.length == 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar al menos una ciudad.",
          color: "error",
        });
        return;
      }
      let me = this;

      
      
      me.id_ciudad.sort((a, b) => a - b);

      console.log("ciudad",me.id_ciudad);

      if (!this.showTablaCargos) {
        console.log ("actualizar",me.itemCargo);
        axios
          .put("api/uniforme_cargos/actualizar", {
            id : me.itemCargo.id,
            id_uniforme: me.itemCargo.id_uniforme,
            id_cargo: me.idCargo,
            id_ciudad: me.id_ciudad,
            frecuencia: me.frecuencia,           
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCargo();
            me.listarUniformeCargo();
            me.id_cargo = [];

            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error.response.data, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/Uniforme_cargos/crear", {
            id_uniforme: me.id,
            id_cargo: me.id_cargo,
            id_ciudad: me.id_ciudad,
            frecuencia: me.frecuencia,            
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCargo();
            me.listarUniformeCargo();
            me.id_cargo = [];

            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarCargo() {
      this.validaCargo = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formCargo).forEach((f) => {
        console.log(f);
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaCargo += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaCargo += 1;
        }
      });
      return this.validaCargo;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/uniformes/activar/" + item.id + "/" + item.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "info",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/uniformes/desactivar/" + item.id + "/" + item.usuario, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "accent",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    filtroCodigo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCodigoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },
    filtroDescripcion(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchDescripcionValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchDescripcionValue.toLowerCase());
    },
  },
};
</script>
